import { useQuery } from "@tanstack/react-query";

import { fetchAudit } from "../api/audit";

export function useAudit(limit: number = 200) {
  return useQuery({
    queryKey: ["audit", limit],
    queryFn: () => fetchAudit(limit),
    staleTime: 10_000,
  });
}
